export const DISCUSSION_KEEP_MS = 900_000;
export const discussionLifetimes: Readonly<Record<string, number>> = {
  disabled: 0, changed: 0, waiting: 0, blocked: 3_600_000, restricted: 3_600_000, failed: 60_000,
};
